import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import classNames from 'classnames';

import { ChirpButton } from 'javascripts/components/chirp_button';

import styles from 'stylesheets/components/modal.module';

import closeIcon from 'images/x-icon-gray';

export function Modal(props) {
  function renderCloseButton() {
    if (!props.closeable) {
      return null;
    }

    const closeButtonProps = _.isNil(props.closeText)
      ? { icon: closeIcon, iconAltText: 'Close Modal', iconSize: 'extraLarge' }
      : { label: props.closeText };

    return (
      <ChirpButton
        class={styles.closeButton}
        displayStyle='bold'
        displayType='link'
        onClick={_.partial(props.onRequestClose, { closeButton: true })}
        {...closeButtonProps}
      />
    );
  }

  return (
    <ReactModal
      ariaHideApp={false}
      contentLabel={props.title}
      isOpen={props.isOpen}
      className={classNames(styles.modal, { [styles.darkHeader]: props.darkHeader })}
      overlayClassName={styles.overlay}
      bodyOpenClassName={styles.modalOpen}
      onRequestClose={props.onRequestClose}
      shouldCloseOnOverlayClick={props.closeable}
      shouldCloseOnEsc={props.closeable}
    >
      {renderCloseButton()}
      <header className={styles.header}>
        {!_.isNil(props.title) ? <h2 className={styles.title}>{props.title}</h2> : null}
        {!_.isNil(props.header) ? props.header : null}
      </header>
      <div className={styles.content}>{props.children}</div>
    </ReactModal>
  );
}

Modal.propTypes = {
  closeText: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  header: PropTypes.element,
  title: PropTypes.string,
  onRequestClose: PropTypes.func,
  closeable: PropTypes.bool,
  darkHeader: PropTypes.bool,
};

Modal.defaultProps = {
  closeable: true,
  darkHeader: false,
  onRequestClose: _.noop,
};
